import { Control, Controller } from "react-hook-form";

import Input from "@/components/Atoms/InputsV2/TextInput";
import ErrorUI from "@/components/Atoms/InputsV2/ErrorUI";

import { classNameGenerator } from "@/utils";

import styles from "./NameInput.module.scss";

interface NameInputProps {
  name: string;
  control: Control<any>;
  placeholder?: string;
  className?: string;
  onBlur?: (e: any) => void;
  setFormData?: any;
  formData?: any;
  removeAppliedPromoCode?: (e: any) => void
}

export const isValidName = (value) =>
  value &&
  (value.match(/^[a-zA-Z\s]*$/) || value === "") &&
  value.length <= 140;

const NameInput: React.FC<NameInputProps> = ({
  name,
  control,
  placeholder = "Enter your name",
  onBlur = () => {},
  setFormData = () => {},
  formData = {},
  removeAppliedPromoCode = () => {},
  ...rest
}) => {
  const cls = classNameGenerator(styles);

  const validateName = (e) => {
    const value = e.target.value;
    return value === "" || isValidName(value);
  };

  return (
    <div className={cls("nameInput")}>
      <Controller
        name={name}
        control={control}
        shouldUnregister
        render={({
          field: { value, onBlur: handleBlur, onChange, ref },
          fieldState: { error },
        }) => (
          <>
            <Input
              ref={ref}
              placeholder={placeholder}
              name={name}
              value={value || formData?.name}
              onChange={(e) => {
                if (validateName(e)) {
                  onChange(e);
                  setFormData((prev) => {
                    return {...prev,[name]:e.target.value}
                  })
                  removeAppliedPromoCode(false)
                }
              }}
              onBlur={(e) => {
                handleBlur();
                onBlur(e);
                removeAppliedPromoCode(false)
              }}
              {...rest}
            />
            <ErrorUI error={error?.message} />
          </>
        )}
      />
    </div>
  );
};

export default NameInput;
